import { DestroyRef, inject, Injectable, signal, WritableSignal } from '@angular/core';
import { cdnUrl } from 'apps/ihowebsite/src/app/app.module';
import { SearchRepository } from '@core/services/repositories/search.repository';
import { SearchBoxService } from './serach-box.service';

@Injectable({
 providedIn: 'root',
})
export class AutocompleteService {
 adCode = signal(false);
 // route = inject(ActivatedRoute);
 // queryParams: Record<string, string> = {};

 constructor() {
  //  this.queryParams = this.route.snapshot.queryParams;
  this.setState('hide');
  this.setResult([]);
 }
 /*
          - inject
      */
 destroyRef = inject(DestroyRef);
 searchRepository = inject(SearchRepository);
 searchBoxService = inject(SearchBoxService);

 public _favorite: WritableSignal<Array<any>> = signal([
  {
   id: 19,
   type: 1,
   name: 'تهران',
   state: 'تهران',
   link: '/tehran-hotels/',
   image: `${cdnUrl}/images/searchbox-tehran.jpg`,
  },
  {
   id: 54,
   type: 1,
   name: 'مشهد',
   state: 'خراسان رضوی',
   link: '/mashhad-hotels/',
   image: `${cdnUrl}/images/searchbox-mashhad.jpg`,
  },
  {
   id: 5,
   type: 1,
   name: 'اصفهان',
   state: 'اصفهان',
   link: '/isfahan-hotels/',
   image: `${cdnUrl}/images/searchbox-esfehan.jpg`,
  },
  {
   id: 37,
   type: 1,
   name: 'شیراز',
   state: 'فارس',
   link: '/shiraz-hotels/',
   image: `${cdnUrl}/images/searchbox-shiraz.jpg`,
  },
  {
   id: 59,
   type: 1,
   name: 'یزد',
   state: 'یزد',
   link: '/yazd-hotels/',
   image: `${cdnUrl}/images/searchbox-yazd.jpg`,
  },
  {
   id: 46,
   type: 1,
   name: 'کیش',
   state: 'هرمزگان',
   link: '/kish-hotels/',
   image: `${cdnUrl}/images/searchbox-kish.jpg`,
  },
 ]);
 public _isMobile: WritableSignal<boolean> = signal(false);
 public _key: WritableSignal<string> = signal('');
 public _recent: WritableSignal<Array<any>> = signal([]);
 public _recentSelectedItem: WritableSignal<any> = signal([]);
 public _result: WritableSignal<any> = signal([]);
 public _selectedItem: WritableSignal<any> = signal({});
 public _state: WritableSignal<string> = signal('hide');
 public _toggle: WritableSignal<boolean> = signal(true);
 public _hasTyped: WritableSignal<boolean> = signal(false);

 setFavorite(value: Array<any>) {
  this._favorite.set(value);
 }

 setIsMobile(value: boolean) {
  this._isMobile.set(value);
 }

 setKey(value: string) {
  this._key.set(value);
 }
 setHasTyped(value: boolean) {
  this._hasTyped.set(value);
}

 setRecent(
  value: Array<{
   id: number;
   type: number;
   CityName: string;
   province: string;
   country: string;
   date: string;
   endDate: string;
   adultNumber: number;
   childNumber: number;
   search_box: string;
  }>
 ) {
  this._recent.set(value);
 }

 setResult(value: any) {
  this._result.set(value);
 }

 setSelectedItem(value: any) {
  // this.queryParams = this.route.snapshot.queryParams;
  const urlToRedirect = value.link;
  this._recentSelectedItem.set({
   id: value?.id,
   name: value?.name,
   type: value?.type,
   isShabAdsCode: this.adCode(),
    link: this.adCode() ? urlToRedirect : 
    this.searchBoxService.accommodation() == 'ecolodge'
     ? '/ecolodge/' + value?.name
     : urlToRedirect,
   state: value?.state,
   ecolodge: this.searchBoxService.accommodation() == 'ecolodge',
  });
  this._selectedItem.set({
   id: value?.id,
   name: value?.name,
   type: value?.type,
   isShabAdsCode: this.adCode(),
   link:
    this.searchBoxService.accommodation() == 'ecolodge' && !this.adCode
     ? '/ecolodge/' + value?.name
     : urlToRedirect,
   state: value?.state,
  });
 }

 setState(value: string) {
  this._state.set(value);
 }

 setToggle(value: boolean) {
  this._toggle.set(value);
 }
 showFavoriteState() {
  this.adCode.set(false);
  this.setResult([]);
  this._isMobile.set(true);
  this.setState('favorite');
}
fetchHotelInfoSuggest(value: string) {
  const trimmedValue = value?.trim() ?? '';

  if (trimmedValue.length) {
    this.setHasTyped(true);
  }

  if (!trimmedValue.length) {
    this.adCode.set(false);
    this.setResult([]);
      this.setState('favorite');
    return;
  }

  const isSearchNumber = /^\d+$/.test(trimmedValue);
  this.adCode.set(isSearchNumber);

  const isAccomodation =
    this.searchBoxService.accommodation() === 'ecolodge' ||
    this.searchBoxService.accommodation() === 'villa-mashhad';

  this.searchRepository
    .fetchHotelInfoSuggest(trimmedValue, isAccomodation)
    .subscribe((response) => {
      if (response?.length) {
        this.setResult(response);
        this.setState('result');
      } else {
        this.setResult(trimmedValue);
        this.setState(
          this.searchBoxService.accommodation() === 'ecolodge'
            ? 'nothing-ecolodge'
            : 'nothing'
        );
      }
    });
}


}
